import React from 'react';
import './App.css';
import Map from './Map/index'

function App() {
  return (
    <div>
      <Map />
    </div>
  );
}

export default App;
